'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	asyncIterator = require('@mindmup/js-utils/src/async-iterator');

module.exports = function GoogleMigrationModel(config, authenticationModel, googleAuthenticator, googlePicker, googleRTFile, assetLocaliser, s3FileModel, googleDriveService) {
	if (!config || !authenticationModel || !googleAuthenticator || !googlePicker || !googleRTFile || !s3FileModel) {
		throw new Error('invalid-args');
	}
	let googleMMProfile = false, migrationInProgress = false;
	const obj = observable(this),
		selectedFiles = [],
		sameProfile = (profile1, profile2) => profile1.provider === profile2.provider && profile1.providerProfile.id === profile2.providerProfile.id,
		countFilesByState = state => selectedFiles.length && selectedFiles.filter(file => file.state === state).length,
		setGoogleProfile = mmProfile => {
			if (!sameProfile(googleMMProfile, mmProfile)) {
				selectedFiles.splice(0);
			}
			googleMMProfile = mmProfile;
		},
		buildContext = () => {
			const allowedActions = [];
			if (!migrationInProgress) {
				allowedActions.push('canChangeGoogleProfile');
				if (googleMMProfile) {
					if (selectedFiles.length) {
						allowedActions.push('canChangeFiles');
					} else {
						allowedActions.push('canPickFiles');
					}
				}
				if (selectedFiles.filter(file => file.state === 'picked').length) {
					allowedActions.push('canStartMigration');
				}
			}
			return {
				allowedActions: allowedActions,
				migrationInProgress: migrationInProgress,
				googleEmail: googleMMProfile && googleMMProfile.description,
				hasSelectedFile: !!selectedFiles.length,
				selectedFiles: selectedFiles,
				migrationComplete: !migrationInProgress && (selectedFiles.length > 0) && !countFilesByState('picked')
			};
		},
		sendContext = () => {
			const context = buildContext();
			obj.dispatchEvent('context', context);
		},
		migrateFile = (selectedFile) => {
			selectedFile.state = 'migrating';
			sendContext();
			return googleRTFile.getAggregate(googleMMProfile, selectedFile.googleFileInfo)
			.then((activeContent) => assetLocaliser.localise(activeContent))
			.then((localisedContent) => s3FileModel.createFile(selectedFile.fileName, false, JSON.stringify(localisedContent, null, 2)))
			.then((saveConfiguration) => {
				selectedFile.state = 'complete';
				selectedFile.saveConfiguration = saveConfiguration;
				sendContext();
			})
			.then(() => googleDriveService.patchAppProperties(selectedFile.googleFileInfo.id, {migrated: `app:${selectedFile.saveConfiguration.savedFileId}`}))
			.catch((reason) => {
				selectedFile.state = 'error';
				selectedFile.error = reason;
				sendContext();
			});
		};

	obj.migrateFiles = function () {
		migrationInProgress = true;
		return asyncIterator(selectedFiles, migrateFile)
		.catch(() => false)
		.then(() => {
			migrationInProgress = false;
			sendContext();
		});
	};

	authenticationModel.addEventListener('authenticatedProfile', mmProfile => {
		if (mmProfile.provider === googleAuthenticator.providerName()) {
			setGoogleProfile(mmProfile);
		}
		sendContext();
	});

	obj.chooseGoogleAccount = () => {
		return googleAuthenticator.changeAccount()
		.then(mmProfile => {
			setGoogleProfile(mmProfile);
			sendContext();
		})
		.catch(() => false);
	};

	obj.pickFileToMigrate = () => {
		// if (!navigatorShim.hasWindowFlag('cookieCheck')) {
		// 	obj.dispatchEvent('cookies-blocked');
		// 	return Promise.reject('cookies-blocked');
		// }
		return googlePicker.pickFileForImport(googleMMProfile, 'Select one or more files to migrate', {
			multiSelect: true,
			mimeTypes: 'application/vnd.mindmup,application/octet-stream,application/json',
			disableUpload: true
		})
		.then(pickedFiles => {
			selectedFiles.splice(0);
			pickedFiles.forEach(fileInfo => {
				selectedFiles.push({googleFileInfo: fileInfo, state: 'picked', fileName: fileInfo.name});
			});
			sendContext();
		})
		.catch(() => false);
	};
};

